import * as React from 'react';

const NewWindowSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="new-window_svg__eds-icon--new-window_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="new-window_svg__eds-icon--new-window_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 3h13v15H7.7l5.8-5.8V16h1v-5.5H9v1h3.9L7 17.4V3zM6 19h15V2H6v17z"
        />
        <path
            id="new-window_svg__eds-icon--new-window_corner"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 12v10h9v-1H4v-9z"
        />
    </svg>
);

NewWindowSvg.displayName = 'NewWindowSvg';
export default NewWindowSvg;
